module.exports = {
  GraficaD3: {
    PluginName: "Gráfico",
    style: "Estilo",
    margin: "Margin",
    left: "Izquierda",
    right: "Derecha",
    top: "Superior",
    bottom: "Inferior",
    padding: "Padding",
    border_width: "Ancho de borde",
    border_style: "Estilo de borde",
    border_color: "Color de borde",
    border_radius: "Radio de borde",
    opacity: "Opacidad",
    name: "Nombre",
    axis: "Eje",
    axes_v: "Ejes verticales",
    axes_h: "Eje horizontal",
    ring: "Anillo",
    rings: "Anillos",
    title: "Título",
    grid: "Rejilla",
    Graph: "Gráfica",
    number_graphs: "Número de Gráficas",
    see_grid: "Ver rejilla",
    edit: "Editar",
    color: "Color",
    x_grid: "Rejilla eje x",
    y_grid: "Rejilla eje y",
    line_color: "Color de línea",
    file: "Elegir Archivo",
    or: "O rellenar la tabla",
    x_axis: "Eje X",
    y_axis: "Eje Y",
    chart_type: "Tipo de gráfico",
    order_by: "Ordenar Por",
    data_rows: "Nº Filas",
    data_cols: "Nº Columnas",
    key: "Clave",
    value: "Valor",
    vertical: "Vertical",
    horizontal: "Horizontal",
    alert_msg: "Rellena todos los campos de la tabla",
    confirm: "Confirmar",
    fill_in: "O rellena una tabla",
    show: "Mostrar",
    preview: "Previsualización",
    Row: "Fila",
    Column: "Columna",
    row_name: "Nombre Del Gráfico",
    types: {
      line: "Línea",
      area: "Área",
      bar: "Barras",
      pie: "Tarta",
    },
    header: {
      options: "Opciones de la gráfica",
      origin: "Fuente de datos",
      preview: "Previsualización",
    },
    example: {
      example_name_surname_txt: "Nombre Apellido",
      example_age_txt: "Edad",
      example_country_txt: "País",
      examplename1: "Adriana Cruz",
      examplename2: "Carletta Flores",
      exampleage1: "25",
      exampleage2: "41",
    },
  },
};
